import { render, staticRenderFns } from "./AddItemDisount.vue?vue&type=template&id=df55909c&scoped=true&"
import script from "./AddItemDisount.vue?vue&type=script&lang=js&"
export * from "./AddItemDisount.vue?vue&type=script&lang=js&"
import style0 from "./AddItemDisount.vue?vue&type=style&index=0&id=df55909c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df55909c",
  null
  
)

export default component.exports